<div class="container">
  <nb-card>
    <nb-card-header>
      <h6><nb-icon icon="layers-outline"></nb-icon>{{ 'pages.settings.agentModel.title' | translate }}</h6>
    </nb-card-header>
    <nb-card-body>
      @if (loading) {
        <app-page-loader></app-page-loader>
      } @else if (choice) {
        <p class="agent-model__intro">{{ 'pages.settings.agentModel.intro' | translate }}</p>
        <p class="agent-model__current">
          {{ 'pages.settings.agentModel.current' | translate }}
          <strong>{{ choice.effective?.model_label || choice.platform_default.model_label }}</strong>
          @if (!choice.effective) { ({{ 'pages.settings.agentModel.platformDefault' | translate }}) }
        </p>

        @if (choice.can_manage) {
          <section class="tile-flat">
            <header class="tile-flat__header"><h5>{{ 'pages.settings.agentModel.organisation' | translate }}</h5></header>
            <label class="label" for="agent-model-org">{{ 'pages.settings.agentModel.model' | translate }}</label>
            <nb-select id="agent-model-org" fullWidth [(selected)]="orgProvider">
              <nb-option [value]="none">
                {{ 'pages.settings.agentModel.platformOption' | translate: { model: choice.platform_default.model_label } }}
              </nb-option>
              @for (p of choice.providers; track p.provider) {
                <nb-option [value]="p.provider">
                  {{ p.model_label }} · {{ p.provider }} · ×{{ p.credit_multiplier }}
                  @if (p.agent_status === 'hint') { · {{ 'pages.settings.agentModel.lessTested' | translate }} }
                </nb-option>
              }
            </nb-select>
            <div class="agent-model__toggle">
              <nb-toggle [(checked)]="allowUsers" status="primary">
                {{ 'pages.settings.agentModel.allowUsers' | translate }}
              </nb-toggle>
            </div>
            @if (orgDirty) {
              <div class="agent-model__actions">
                <button nbButton status="primary" shape="round" type="button" [nbSpinner]="savingOrg" [disabled]="savingOrg" (click)="saveOrganisation()">
                  {{ 'buttons.save' | translate }}
                </button>
              </div>
            }
          </section>
        }

        @if (choice.organisation.allow_user_choice) {
          <section class="tile-flat">
            <header class="tile-flat__header"><h5>{{ 'pages.settings.agentModel.mine' | translate }}</h5></header>
            <label class="label" for="agent-model-me">{{ 'pages.settings.agentModel.model' | translate }}</label>
            <nb-select id="agent-model-me" fullWidth [(selected)]="myProvider">
              <nb-option [value]="none">{{ 'pages.settings.agentModel.likeOrganisation' | translate }}</nb-option>
              @for (p of choice.providers; track p.provider) {
                <nb-option [value]="p.provider">
                  {{ p.model_label }} · {{ p.provider }} · ×{{ p.credit_multiplier }}
                  @if (p.agent_status === 'hint') { · {{ 'pages.settings.agentModel.lessTested' | translate }} }
                </nb-option>
              }
            </nb-select>
            @if (myDirty) {
              <div class="agent-model__actions">
                <button nbButton status="primary" shape="round" type="button" [nbSpinner]="savingMine" [disabled]="savingMine" (click)="saveMine()">
                  {{ 'buttons.save' | translate }}
                </button>
              </div>
            }
          </section>
        }

        <p class="agent-model__hint">{{ 'pages.settings.agentModel.hint' | translate }}</p>
      }
    </nb-card-body>
  </nb-card>
</div>
